import _styled from "styled-components";
var _excluded = ["className", "style", "children", "variant", "padding", "maxWidth"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType, variantSwitch } from '@adsk/alloy-react-helpers';
import theme from '@adsk/alloy-react-theme';
import { VARIANTS } from '../consts';
var Body = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _variants;

  var className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? VARIANTS.DARK : _ref$variant,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? '8px 12px' : _ref$padding,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '300px' : _ref$maxWidth,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    className: className,
    ref: ref
  }, props, {
    $_css: [theme.typography.bodySmall, {
      padding: padding,
      maxWidth: maxWidth,
      overflowWrap: 'break-word'
    }, variantSwitch({
      statement: variant,
      variants: (_variants = {}, _defineProperty(_variants, VARIANTS.LIGHT, {
        color: theme.colors.charcoal900,
        backgroundColor: theme.colors.white,
        borderRadius: 4,
        boxShadow: theme.shadows.highElevation
      }), _defineProperty(_variants, VARIANTS.DARK, {
        color: theme.colors.white,
        backgroundColor: theme.colors.charcoal900,
        borderRadius: 2
      }), _variants)
    }), style]
  }), children);
});
Body.displayName = 'Body';
Body.propTypes = {
  /** className */
  className: PropTypes.string,

  /** style */
  style: stylePropType,

  /** children */
  children: PropTypes.node,

  /** variants */
  variant: PropTypes.oneOf(Object.values(VARIANTS)),

  /** padding */
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** maxWidth */
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default Object.assign(Body, {
  VARIANTS: VARIANTS
});

var _StyledDiv = _styled("div").withConfig({
  displayName: "Body___StyledDiv",
  componentId: "sc-5ahg19-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=Body.js.map